// components/HelpModal/ShadowTab.jsx
import React from "react";
import "./ShadowTab.css";

const ShadowTab = () => {
  return (
    <div className="shadow-tab">
      <div className="shadow-tab-section">
        <h4>🎯 تکنیک سایه (Shadowing) برای یادگیری زبان</h4>
        <p>
          این تکنیک به شما کمک می‌کنه با تکرار هوشمند، تلفظ و لهجه خودتون رو
          بهبود بدید. با این روش می‌تونید مثل یک سایه، همزمان با گوینده صحبت
          کنید!
        </p>
      </div>

      <div className="shadow-tab-section">
        <h4>مراحل استفاده:</h4>
        <div className="shadow-tab-steps">
          <div className="shadow-tab-step">
            ① کادر فرآیند رو از تنظیمات فعال کنید
          </div>
          <div className="shadow-tab-step">
            ② روی دکمه "شروع" کلیک کنید تا زمان شروع جمله ثبت بشه
          </div>
          <div className="shadow-tab-step">
            ③ روی دکمه "پایان" کلیک کنید تا زمان پایان جمله ثبت بشه
          </div>
          <div className="shadow-tab-step">
            ④ تعداد تکرار و تنظیمات هر تکرار رو مشخص کنید
          </div>
          <div className="shadow-tab-step">
            ⑤ دکمه "شروع تکنیک سایه" رو بزنید و همزمان با فیلم تکرار کنید!
          </div>
        </div>
      </div>

      <div className="shadow-tab-section">
        <h4>تنظیمات پیشرفته هر تکرار:</h4>
        <div className="shadow-tab-settings">
          <div className="shadow-tab-setting">
            🔊 ولوم صدا: کنترل میزان صدا در هر تکرار
          </div>
          <div className="shadow-tab-setting">
            ⏱️ سرعت پخش: از ۰.۵x (آهسته) تا ۳x (تند)
          </div>
          <div className="shadow-tab-setting">
            👁️ نمایش: زیرنویس کامل نمایش داده میشه
          </div>
          <div className="shadow-tab-setting">🙈 پنهان: زیرنویس دیده نمیشه</div>
          <div className="shadow-tab-setting">
            🕵️ زیر کاور: زیرنویس کمرنگه و با هاور کامل میشه
          </div>
        </div>
      </div>

      <div className="shadow-tab-section shadow-tab-tips">
        <h4>💡 نکات مهم:</h4>
        <ul>
          <li>هر تکرار می‌تونه تنظیمات متفاوتی داشته باشه</li>
          <li>مثلاً: اول آهسته با زیرنویس، بعد تندتر بدون زیرنویس</li>
          <li>
            هدف نهایی اینه که بدون دیدن زیرنویس و با سرعت عادی بتونید همزمان
            صحبت کنید
          </li>
          <li>
            با کلیک روی دکمه "شروع" و "پایان" در هر لحظه از فیلم، زمان‌ها به‌روز
            میشن
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ShadowTab;
